import _get from 'lodash/get'
import _isEmpty from 'lodash/isEmpty'

export class VerificationPepInfoRecord {
  constructor (record) {
    this._record = record
    this.data = _get(record, 'data')
  }

  get isNotEmptyData () {
    return !_isEmpty(this.data)
  }
  get isMediaNotEmpty () {
    return !_isEmpty(this.data.media)
  }
  get isAkaNotEmpty () {
    return !_isEmpty(this.data.aka)
  }
  get isAssociatesNotEmpty () {
    return !_isEmpty(this.data.associates)
  }
  get isSourcesNotEmpty () {
    return !_isEmpty(this.data.sources)
  }
  get isSourceNotesNotEmpty () {
    return !_isEmpty(Object.keys(this.data.sourceNotes))
  }
  get isFieldsNotEmpty () {
    return !_isEmpty(this.data.fields)
  }
  get isTypesNotEmpty () {
    return !_isEmpty(this.data.types)
  }
}
